import React, { useState } from "react";
import { NavigationBase } from "@reusejs/react";

export default function RightSidbar(props: any) {
  const { children, isOpen, setIsOpen } = props;

  const Help = () => <div className="text-2xl font-bold">Help</div>;
  const CloseIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className="h-8 w-8 cursor-pointer"
      onClick={() => {
        setIsOpen(false);
      }}
    >
      <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
    </svg>
  );

  return (
    <main
      className={
        " fixed overflow-hidden z-10 bg-gray-900 bg-opacity-25 inset-0 transform ease-in-out " +
        (isOpen
          ? " transition-opacity opacity-100 duration-500 translate-x-0  "
          : " transition-all delay-500 opacity-0 translate-x-full  ")
      }
    >
      <section
        className={
          " w-screen max-w-lg right-0 absolute bg-white h-full shadow-xl delay-400 duration-500 ease-in-out transition-all transform  " +
          (isOpen ? " translate-x-0 " : " translate-x-full ")
        }
      >
        <article className="relative w-screen max-w-lg pb-10 flex flex-col space-y-6 overflow-y-scroll h-full">
          <NavigationBase
            left={CloseIcon}
            middle={Help}
            backgroundClasses="bg-white fixed top-0 z-20 left-0 right-0 dark:bg-[#12263f] "
            widthClasses="mx-auto w-full px-6"
            leftArrangement="none"
            middleArrangement="w-full justify-center"
            rightArrangement="none"
            borderClasses="relative border-b border-gray-200 dark:border-blue-800"
          />
          <div className="pt-20 px-4">{children}</div>
        </article>
      </section>
      <section
        className=" w-screen h-full cursor-pointer "
        onClick={() => {
          setIsOpen(false);
        }}
      ></section>
    </main>
  );
}
